import { type ClassDetailsForm } from '~entities/classes/api/create-class';
import { getHourlyTuitionBillingId } from '~entities/classes/helpers/get-hourly-tuition-billing-id';
import type { ClassDetails } from '~entities/classes/modal/class';

export const defaultCopyTitle = (title: string) => `${title} (Copy)`;

export function offeringSessionId(
  offering: Pick<ClassDetails, 'session'>,
): string | null {
  const id = offering.session?._id?.trim();
  return id || null;
}

export function buildClassDetailsFormFromClass(
  c: ClassDetails,
  title: string,
  options?: { hideOverride?: boolean },
): ClassDetailsForm {
  const sessionId = offeringSessionId(c);
  if (!sessionId) {
    throw new Error('Cannot copy offering: session is required');
  }

  return {
    title,
    description: c.description ?? '',
    location: c.location?._id ?? null,
    room: c.room?._id ?? null,
    instructor: c.instructor?.map((i) => i._id) ?? [],
    tags: c.tags?.map((t) => t._id) ?? [],
    group: c.group?.map((g) => g._id) ?? [],
    hide: options?.hideOverride !== undefined ? options.hideOverride : c.hide,
    color: c.color,
    startDate: c.startDate,
    endDate: c.endDate,
    startTime: c.startTime,
    endTime: c.endTime,
    days: c.days,
    duration: c.duration,
    isPrivateLesson: c.isPrivateLesson ?? false,
    slotInterval: c.slotInterval,
    session: sessionId,
    startYear: c.startYear,
    startMonth: c.startMonth,
    endYear: c.endYear,
    endMonth: c.endMonth,
    maxSize: c.maxSize,
    policyGroup: c.policyGroup?.map((p) => p._id) ?? [],
    registrationStartDate: c.registrationStartDate ?? '',
    registrationFeeAmount: c.registrationFeeAmount,
    prorateTuition: c.prorateTuition,
    tuitionFee: c.tuitionFee,
    costumeFee: c.costumeFee ?? 0,
    tuitionBillingCycle: c.tuitionBillingCycle,
    billingFrequencyDays: c.billingFrequencyDays,
    hourlyTuitionBillingId: getHourlyTuitionBillingId(c.hourlyTuitionBillingId),
    billingDay: c.billingDay,
    availability: c.availability,
    timeConfig: c.timeConfig,
    displayOnWebsite: c.displayOnWebsite,
    allowOnlineRegistration: c.allowOnlineRegistration,
    allowPortalEnrollment: c.allowPortalEnrollment,
    allowTrialEnrollment: c.allowTrialEnrollment,
    includeInPublicSchedule: c.includeInPublicSchedule ?? false,
    acceptsMakeups: c.acceptsMakeups,
  };
}

export function offeringImageUrl(
  offering: Pick<ClassDetails, 'imageUrl'>,
): string {
  return offering.imageUrl?.trim() ?? '';
}
